/* eslint-disable jsx-a11y/aria-role */
import { h, Fragment } from 'preact'
import { DecorationTop, DecorationBottom, Quote, Snakkedurt } from './Decorations/Decorations'
import { Swipe, SwipeItem } from '../../shared/Swipe/Swipe'
import { Message } from '../../../../lib/intl/Message'
import cx from 'classnames'

import styles from './Pastander.module.css'

export function PastandModul(props: any) {
  const { pastander, parti } = props
  return (
    <Swipe
      class={styles.swipeWrapper}
      style={{ '--swipe-dot-active-color': `${parti.farge}` }}
      items={pastander.map((pastand, idx) => {
        const itemFirst = idx === 0
        const itemLast = idx === pastander.length - 1
        return (
          <SwipeItem
            class={cx(styles.item, itemFirst && styles.itemFirst, itemLast && styles.itemLast)}
          >
            <div class={styles.flexWrap}>
              <DecorationTop parti={parti} aria-hidden="true" />
              <DecorationBottom parti={parti} aria-hidden="true" />
              <div
                role="text"
                class={styles.pastandWrapper}
                style={{ '--underline-color': `${parti.farge}` }}
              >
                <Quote parti={parti} aria-hidden="true" />
                <Message
                  as="h4"
                  id={`hva-mener-partiene-pastand-tittel-${
                    pastand.stasted === -2 ? 'uenig' : 'enig'
                  }`}
                  values={{
                    parti: parti.navn
                  }}
                />
                <p class={styles.pastandText}>
                  &ndash; <span dangerouslySetInnerHTML={{ __html: pastand.tekst }} />
                </p>
                <Snakkedurt aria-hidden="true" />
              </div>
            </div>
          </SwipeItem>
        )
      })}
    />
  )
}
